/* eslint-disable camelcase */
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getSIVProductInventoryTransactions = (query) => {
  const { itemsPerPage, currentPage, sortBy, sortOrder, keyword, start_date, end_date, type, partner_id } = query;
  const itemOffset = (currentPage - 1) * itemsPerPage;
  
  let queryString = `&limit=${itemsPerPage || 10}&skip=${itemOffset || 0}`;

  if (sortBy) {
    const sortDirection = sortOrder < 0 ? '-' : '';
    queryString += `&sort=${sortDirection}${sortBy}`;
  }
  
  if (keyword) {
    queryString += `&keyword=${encodeURIComponent(keyword)}`;
  }

  if (start_date) {
    queryString += `&start_date=${encodeURIComponent(start_date)}`;
  }

  if (end_date) {
    queryString += `&end_date=${encodeURIComponent(end_date)}`;
  }

  if (type && type !== 'all') {
    queryString += `&type=${encodeURIComponent(type)}`;
  }

  if (partner_id && partner_id !== 'all') {
    queryString += `&partner_id=${encodeURIComponent(partner_id)}`;
  }

  return API.get(`${getApiUrl()}/api/siv-product-inventory-transaction?${queryString}`);
};

export const getSIVProductInventoryTransactionById = (id) => {
  return API.get(`${getApiUrl()}/api/siv-product-inventory-transaction/${id}`);
};

export const setSIVProductInventoryTransaction = (data) => {
  return API.post(`${getApiUrl()}/api/siv-product-inventory-transaction`, data);
};

export const updateSIVProductInventoryTransaction = (id, data) => {
  return API.put(`${getApiUrl()}/api/siv-product-inventory-transaction/${id}`, data);
};

export const deleteSIVProductInventoryTransaction = (id) => {
  return API.delete(`${getApiUrl()}/api/siv-product-inventory-transaction/${id}`);
};

export const updateSIVProductInventoryTransactionDate = (id, transaction_date) => {
  return API.put(`${getApiUrl()}/api/siv-product-inventory-transaction/${id}/transaction-date`, {
    transaction_date
  });
};

export const sivProductInventoryTransactionService = {
  getSIVProductInventoryTransactions,
  getSIVProductInventoryTransactionById,
  setSIVProductInventoryTransaction,
  updateSIVProductInventoryTransaction,
  deleteSIVProductInventoryTransaction,
  updateSIVProductInventoryTransactionDate
}; 